<script>
import Detail from '@components/details'
import Approval from '@components/approval'
import Update from '@components/updatereport'
import Upload from '@components/uploadreport'
import downloadButton from '@components/downloadButton'
import TableDetail from '@components/table-detail'
import {
  authComputed,
  siteListComputed,
  meetingListMethod,
} from '@state/helpers'
import {
  ADMIN_ROLE,
  TEACHER_ROLE,
  COLLEGE_ROLE,
  ADMINISTRATOR_ROLE,
} from '@utils/constant'
import formatDate from '@utils/format-date'
import formatTime from '@utils/format-time'
import tConvert from '@utils/format-hour'
import BatchUpdate from '@components/batchUpdate'
import AssignedUser from '@components/assignedUsers'
import TeacherDataUpdate from '@components/teacherDataUpdate'
import AssignmentUpdate from '@components/assignmentUpdate'
import CalendarEventUpdate from '@components/calendarEventUpdate'
import CalendarEventDelete from '@components/calendarEventDelete'
import TrainingEventUpdate from '@components/trainingEventUpdate'
import TrainingEventDelete from '@components/trainingEventDelete'
import ResourceUpdate from '@components/resourceUpdate'
import ResourceDelete from '@components/resourceDelete'
import AssignmentDelete from '@components/assignmentDelete'
import MeetingUpdate from '@components/meetingUpdate'
import MeetingDelete from '@components/meetingDelete'
import UserUpdate from '@components/userDataUpdate'
import UserDelete from '@components/userDataDelete'
import TeacherDelete from '@components/teacherDataDelete'
import EventUpdate from '@components/eventDataUpdate'
import EventDelete from '@components/eventDataDelete'
import BlogUpdate from '@components/blogDataUpdate'
import BlogDelete from '@components/blogDataDelete'
import AdminUpdate from '@components/adminDataUpdate'
import AdminDelete from '@components/adminDataDelete'
import CollegeUpdate from '@components/collegeUpdate'
import CollegeDelete from '@components/collegeDelete'
import CollegeClassUpdate from '@components/collegeClassUpdate'
import CollegeClassDelete from '@components/collegeClassDelete'
import CategoryUpdate from '@components/categoryUpdate'
import CategoryDelete from '@components/categoryDelete'
import SubCategoryUpdate from '@components/subCategoryUpdate'
import SubCategoryDelete from '@components/subCategoryDelete'
import CourseUpdate from '@components/courseUpdate'
import CourseDelete from '@components/courseDelete'
import CourseContentUpdate from '@components/courseContentUpdate'
import CourseContentDelete from '@components/courseContentDelete'
import DepartmentUpdate from '@components/departmentUpdate'
import DepartmentDelete from '@components/departmentDelete'
import moment from 'moment'
import 'vuetify/dist/vuetify.min.css'
export default {
  components: {
    Detail: Detail,
    TableDetail: TableDetail,
    Update: Update,
    Upload: Upload,
    DownloadButton: downloadButton,
    Approval: Approval,
    BatchUpdate: BatchUpdate,
    AssignedUser: AssignedUser,
    TeacherDataUpdate: TeacherDataUpdate,
    AssignmentUpdate: AssignmentUpdate,
    CalendarEventUpdate: CalendarEventUpdate,
    CalendarEventDelete: CalendarEventDelete,
    TrainingEventUpdate: TrainingEventUpdate,
    TrainingEventDelete: TrainingEventDelete,
    ResourceUpdate: ResourceUpdate,
    ResourceDelete: ResourceDelete,
    AssignmentDelete: AssignmentDelete,
    MeetingUpdate: MeetingUpdate,
    MeetingDelete: MeetingDelete,
    UserUpdate: UserUpdate,
    UserDelete: UserDelete,
    TeacherDelete: TeacherDelete,
    EventUpdate: EventUpdate,
    EventDelete: EventDelete,
    BlogUpdate: BlogUpdate,
    BlogDelete: BlogDelete,
    AdminUpdate: AdminUpdate,
    AdminDelete: AdminDelete,
    CollegeUpdate: CollegeUpdate,
    CollegeDelete: CollegeDelete,
    CollegeClassUpdate: CollegeClassUpdate,
    CollegeClassDelete: CollegeClassDelete,
    CategoryUpdate: CategoryUpdate,
    CategoryDelete: CategoryDelete,
    SubCategoryUpdate: SubCategoryUpdate,
    SubCategoryDelete: SubCategoryDelete,
    CourseUpdate: CourseUpdate,
    CourseDelete: CourseDelete,
    CourseContentUpdate: CourseContentUpdate,
    CourseContentDelete: CourseContentDelete,
    DepartmentUpdate: DepartmentUpdate,
    DepartmentDelete: DepartmentDelete,
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    tableName: {
      type: String,
      default: '',
    },
    displayFields: {
      type: Array,
      required: false,
      default: () => [],
    },
    htmlFields: {
      type: Array,
      default: () => [],
    },
    striped: {
      type: Boolean,
      required: false,
      default: false,
    },
    bordered: {
      type: Boolean,
      required: false,
    },
    viewbtn: {
      type: Boolean,
      default: false,
    },
    joinbtn: {
      type: Boolean,
      default: false,
    },
    copybtn: {
      type: Boolean,
      default: false,
    },
    deletebtn: {
      type: Boolean,
      default: false,
    },
    editbtn: {
      type: Boolean,
      default: false,
    },
    teacher: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Boolean,
      default: false,
    },
    admin: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Boolean,
      default: false,
    },
    batch: {
      type: Boolean,
      default: false,
    },
    blog: {
      type: Boolean,
      default: false,
    },
    assignment: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: Boolean,
      default: false,
    },
    calendarEvent: {
      type: Boolean,
      default: false,
    },
    trainingEvent: {
      type: Boolean,
      default: false,
    },
    college: {
      type: Boolean,
      default: false,
    },
    department: {
      type: Boolean,
      default: false,
    },
    collegeClass: {
      type: Boolean,
      default: false,
    },
    teacherlist: {
      type: Boolean,
      default: false,
    },
    liveclass: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Boolean,
      default: false,
    },
    subcategory: {
      type: Boolean,
      default: false,
    },
    editcourse: {
      type: Boolean,
      default: false,
    },
    editcoursecontent: {
      type: Boolean,
      default: false,
    },
    addbtn: {
      type: Boolean,
      default: false,
    },
    downloadbtn: {
      type: Boolean,
      default: false,
    },
    updatebtn: {
      type: Boolean,
      default: false,
    },
    uploadbtn: {
      type: Boolean,
      default: false,
    },
    actionBtn: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'xl',
    },
    showdetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      TEACHER_ROLE: TEACHER_ROLE,
      COLLEGE_ROLE: COLLEGE_ROLE,
      ADMINISTRATOR_ROLE: ADMINISTRATOR_ROLE,
      active: 0,
      update: 0,
      upload: 0,
      details: [],
      reportData: [],
      Report: [],
      search: '',
      filterItems: [],
      isSearch: false,
      previousRow: '',
      approvalDetails: [],
      approveActive: 0,
      batchEdit: 0,
      batchData: [],
      showUsers: 0,
      usersData: [],
      teacherEdit: 0,
      teacherData: [],
      assignmentEdit: 0,
      assignmentData: [],
      calendarEventEdit: 0,
      calendarEventData: [],
      trainingEventEdit: 0,
      trainingEventData: [],
      deleteEvent: false,
      deleteData: [],
      deleteTrainingEvent: false,
      deleteTrainingData: [],
      resourceEdit: 0,
      resourceData: [],
      deleteResource: false,
      deleteResourceData: [],
      deleteAssignment: false,
      deleteAssignmentData: [],
      meetingEdit: 0,
      meetingEditData: [],
      meetingDelete: 0,
      meetingDeleteData: [],
      eventUpdate: 0,
      eventUpdateData: [],
      eventDelete: 0,
      eventDeleteData: [],
      blogUpdate: 0,
      blogUpdateData: [],
      blogDelete: 0,
      blogDeleteData: [],
      showSession: 0,
      teacherDelete: 0,
      userUpdate: 0,
      userDelete: 0,
      teacherDeleteData: [],
      userUpdateData: [],
      userDeleteData: [],
      adminUpdate: 0,
      adminUpdateData: [],
      adminDelete: 0,
      adminDeleteData: [],
      collegeUpdate: 0,
      collegeUpdateData: [],
      collegeDelete: 0,
      collegeDeleteData: [],
      collegeClassUpdate: 0,
      collegeClassUpdateData: [],
      collegeClassDelete: 0,
      collegeClassDeleteData: [],
      categoryEdit: 0,
      categoryEditData: [],
      categoryDelete: 0,
      categoryDeleteData: [],
      subCategoryEdit: 0,
      subCategoryEditData: [],
      subCategoryDelete: 0,
      subCategoryDeleteData: [],
      courseEdit: 0,
      courseEditData: [],
      courseDelete: 0,
      courseDeleteData: [],
      courseContentEdit: 0,
      courseContentEditData: [],
      courseContentDelete: 0,
      courseContentDeleteData: [],
      departmentUpdate: 0,
      departmentUpdateData: [],
      departmentDelete: 0,
      departmentDeleteData: [],
    }
  },
  computed: {
    ...authComputed,
    ...siteListComputed,
  },
  methods: {
    ...meetingListMethod,
    getCollegeEdit(data) {
      this.collegeUpdate = 1
      this.collegeUpdateData = data
    },
    getCollegeDelete(data) {
      this.collegeDelete = 1
      this.collegeDeleteData = data
    },
    getCollegeClassEdit(data) {
      this.collegeClassUpdate = 1
      this.collegeClassUpdateData = data
    },
    getDepartmentEdit(data) {
      this.departmentUpdate = 1
      this.departmentUpdateData = data
    },
    getDepartmentDelete(data) {
      this.departmentDelete = 1
      this.departmentDeleteData = data
    },
    getCollegeClassDelete(data) {
      this.collegeClassDelete = 1
      this.collegeClassDeleteData = data
    },
    getAdminEdit(data) {
      this.adminUpdate = 1
      this.adminUpdateData = data
    },
    getAdminDelete(data) {
      this.adminDelete = 1
      this.adminDeleteData = data
    },
    getEventEdit(data) {
      this.eventUpdate = 1
      this.eventUpdateData = data
    },
    getEventDelete(data) {
      this.eventDelete = 1
      this.eventDeleteData = data
    },
    getBlogEdit(data) {
      this.blogUpdate = 1
      this.blogUpdateData = data
    },
    getBlogDelete(data) {
      this.blogDelete = 1
      this.blogDeleteData = data
    },
    getUserDataEdit(data) {
      this.userUpdate = 1
      this.userUpdateData = data
    },
    getUserDelete(data) {
      this.userDelete = 1
      this.userDeleteData = data
    },
    getTeacherDelete(data) {
      this.teacherDelete = 1
      this.teacherDeleteData = data
    },
    getAssignmentEdit(data) {
      this.assignmentEdit = 1
      this.assignmentData = data
    },
    getResourceEdit(data) {
      this.resourceEdit = 1
      this.resourceData = data
    },
    getCalendarEventEdit(data) {
      this.calendarEventEdit = 1
      this.calendarEventData = data
    },
    getMeetingEdit(data) {
      this.meetingEdit = 1
      this.meetingEditData = data
    },
    getMeetingDelete(data) {
      this.meetingDelete = 1
      this.meetingDeleteData = data
    },
    getCategoryEdit(data) {
      this.categoryEdit = 1
      this.categoryEditData = data
    },
    getCategoryDelete(data) {
      this.categoryDelete = 1
      this.categoryDeleteData = data
    },
    getSubCategoryEdit(data) {
      this.subCategoryEdit = 1
      this.subCategoryEditData = data
    },
    getSubCategoryDelete(data) {
      this.subCategoryDelete = 1
      this.subCategoryDeleteData = data
    },
    getCourseEdit(data) {
      this.courseEdit = 1
      this.courseEditData = data
    },
    getCourseDelete(data) {
      this.courseDelete = 1
      this.courseDeleteData = data
    },
    getCourseContentEdit(data) {
      this.courseContentEdit = 1
      this.courseContentEditData = data
    },
    getCourseContentDelete(data) {
      this.courseContentDelete = 1
      this.courseContentDeleteData = data
    },
    getTrainingEventEdit(data) {
      this.trainingEventEdit = 1
      this.trainingEventData = data
    },
    getBatchEdit(data) {
      this.batchEdit = 1
      this.batchData = data
    },
    getTeacherEdit(data) {
      this.teacherEdit = 1
      this.teacherData = data
    },
    getdata(data) {
      if (data.response) {
        this.$router.push({
          path: `/assignment-list/${data._id}`,
        })
      } else {
        this.active = 1
        this.details = data
      }
    },
    approvaldata(data) {
      this.approveActive = 1
      this.approvalDetails = data
    },
    updateReport(data) {
      this.update = 1
      this.reportData = data
    },
    uploadReport(data) {
      this.upload = 1
      this.Report = data
    },
    formatDates(date) {
      return formatDate(date)
    },
    getEventTime(time) {
      return tConvert(formatTime(moment(time).format('HH:mm')))
    },
    getMeetingTime(time) {
      return tConvert(formatTime(time))
    },
    getboxtype(key) {
      if (key === 'phone') {
        return 'number'
      } else {
        return 'text'
      }
    },
    resetFilter() {
      this.searchInput = []
      this.filterItems = []
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },
    redirectMeeting(data1) {
      const Data = { meetingId: JSON.parse(data1.meta).id }
      this.getStartUrl({ Data }).then((resp) => {
        window.open(resp, '_blank')
      })
    },
    redirectCourse(data1) {
      this.$router.push({
        path: `/course-detail/${data1._id}`,
      })
    },
    expandTable(row) {
      this.showSession = 1
      this.$router.push({
        path: `/list-course-content/${row.item._id}`,
      })
    },
    showAssignedUsers(data) {
      this.showUsers = 1
      this.usersData = data
    },
    getCalendarEventDelete(data) {
      this.deleteEvent = true
      this.deleteData = data
    },
    getTrainingEventDelete(data) {
      this.deleteTrainingEvent = true
      this.deleteTrainingData = data
    },
    getResourceDelete(data) {
      this.deleteResource = true
      this.deleteResourceData = data
    },
    getAssignmentDelete(data) {
      this.deleteAssignment = true
      this.deleteAssignmentData = data
    },
    restrictChars(event) {
      if (event.charCode === 32 && !this.search.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
    filterData(value, search, item) {
      search = this.search.toLowerCase()
      if (this.category) {
        let platformData = item.platformData[0]
        let searchName =
          item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        let searchPlatform =
          platformData.site_name
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        return searchName || searchPlatform
      }
      if (this.subcategory) {
        let searchName =
          item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        if (item.categoryData.length >= 1) {
          let categoryData = item.categoryData[0]
          let searchCategory =
            categoryData.name.toLowerCase().indexOf(this.search.toLowerCase()) >
            -1
          return searchName || searchCategory
        } else {
          return searchName
        }
      }
      if (this.department) {
        let collegeData = item.collegeData[0]
        let searchName =
          item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        let searchCollege =
          collegeData.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        return searchName || searchCollege
      }
      if (this.collegeClass) {
        let deptData = item.departmentData[0]
        let searchName =
          item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          item.classCode.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        let searchCollege =
          deptData.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        return searchName || searchCollege
      } else if (this.teacherlist) {
        let deptData = item.departmentData[0]
        let searchName =
          item.first_name.toLowerCase().indexOf(this.search.toLowerCase()) >
            -1 ||
          item.email.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        let searchCollege =
          deptData.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        return (
          (value != null &&
            search != null &&
            (typeof value === 'string' ||
              typeof value === 'number' ||
              typeof value === 'object') &&
            value.toString().toLowerCase().indexOf(search) !== -1) ||
          searchName ||
          searchCollege
        )
      } else if (this.calendarEvent || this.trainingEvent) {
        let searchDate =
          this.formatDates(item.start)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1 ||
          this.formatDates(item.end)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1

        let searchTitle =
          item.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        return searchDate || searchTitle
      } else if (this.event) {
        let searchDate =
          this.formatDates(item.date)
            .toLowerCase()
            .indexOf(search.toLowerCase()) > -1 ||
          this.getEventTime(item.time)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1

        let searchTitle =
          item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          item.category.name.toLowerCase().indexOf(this.search.toLowerCase()) >
            -1 ||
          item.status.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        let searchStatus = false
        if (
          this.search.toLowerCase() === 'yes' ||
          this.search.toLowerCase() === 'ye' ||
          this.search.toLowerCase() === 'y'
        ) {
          searchStatus = item.status.toLowerCase().indexOf('true') > -1
        } else if (this.search.toLowerCase() === 'no') {
          searchStatus = item.status.toLowerCase().indexOf('pending') > -1
        }
        return searchDate || searchTitle || searchStatus
      } else if (this.batch) {
        let searchName =
          item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          item.assigned_by.email
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        let searchCourse = false
        var courseArray = item.course_id.filter((item1) => {
          return (
            item1.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          )
        })
        if (courseArray.length > 0) {
          searchCourse = true
        } else {
          searchCourse = false
        }
        return searchName || searchCourse
      } else if (this.liveclass) {
        let searchDate =
          this.formatDates(item.date)
            .toLowerCase()
            .indexOf(search.toLowerCase()) > -1 ||
          this.getMeetingTime(item.start_time)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1

        let searchTitle =
          item.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          item.description.toLowerCase().indexOf(this.search.toLowerCase()) >
            -1 ||
          item.meeting_id.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        return searchDate || searchTitle
      } else if (this.resource) {
        let searchBatch = false
        var batchArray = item.assigned_to.filter((item1) => {
          if (item1.name !== undefined) {
            return (
              item1.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            )
          } else {
            return item1.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          }
        })
        if (batchArray.length > 0) {
          searchBatch = true
        } else {
          searchBatch = false
        }
        return (
          (value != null &&
            search != null &&
            (typeof value === 'string' ||
              typeof value === 'number' ||
              typeof value === 'object') &&
            value.toString().toLowerCase().indexOf(search) !== -1) ||
          searchBatch
        )
      } else if (this.assignment) {
        let searchDate =
          this.formatDates(item.deadline)
            .toLowerCase()
            .indexOf(search.toLowerCase()) > -1

        return (
          (value != null &&
            search != null &&
            (typeof value === 'string' ||
              typeof value === 'number' ||
              typeof value === 'object') &&
            value.toString().toLowerCase().indexOf(search) !== -1) ||
          searchDate
        )
      } else if (this.admin || this.user) {
        let searchStatus = false
        let deptData = item.departmentData[0]
        let searchDept =
          deptData.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        if (
          this.search.toLowerCase() === 'active' ||
          this.search.toLowerCase() === 'activ' ||
          this.search.toLowerCase() === 'acti' ||
          this.search.toLowerCase() === 'act' ||
          this.search.toLowerCase() === 'ac'
        ) {
          searchStatus =
            item.loginStatus.toString().toLowerCase().indexOf('true') > -1
        } else if (
          this.search.toLowerCase() === 'inactive' ||
          this.search.toLowerCase() === 'inactiv' ||
          this.search.toLowerCase() === 'inacti' ||
          this.search.toLowerCase() === 'inact' ||
          this.search.toLowerCase() === 'inac' ||
          this.search.toLowerCase() === 'ina' ||
          this.search.toLowerCase() === 'in'
        ) {
          searchStatus =
            item.loginStatus.toString().toLowerCase().indexOf('false') > -1
        }
        return (
          (value != null &&
            search != null &&
            (typeof value === 'string' ||
              typeof value === 'number' ||
              typeof value === 'object') &&
            value.toString().toLowerCase().indexOf(search) !== -1) ||
          searchStatus ||
          searchDept
        )
      } else if (this.student) {
        let searchStatus = false
        let deptData = item.departmentData[0]
        let searchDept =
          deptData.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        if (
          this.search.toLowerCase() === 'done' ||
          this.search.toLowerCase() === 'don' ||
          this.search.toLowerCase() === 'do'
        ) {
          searchStatus =
            item.status.toString().toLowerCase().indexOf('true') > -1
        } else if (
          this.search.toLowerCase() === 'pending' ||
          this.search.toLowerCase() === 'pendin' ||
          this.search.toLowerCase() === 'pendi' ||
          this.search.toLowerCase() === 'pend' ||
          this.search.toLowerCase() === 'pen' ||
          this.search.toLowerCase() === 'pe'
        ) {
          searchStatus =
            item.status.toString().toLowerCase().indexOf('false') > -1
        }
        return (
          (value != null &&
            search != null &&
            (typeof value === 'string' ||
              typeof value === 'number' ||
              typeof value === 'object') &&
            value.toString().toLowerCase().indexOf(search) !== -1) ||
          searchStatus ||
          searchDept
        )
      } else {
        return (
          value != null &&
          search != null &&
          (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'object') &&
          value.toString().toLowerCase().indexOf(search) !== -1
        )
      }
    },
    copyMeetingUrl(data) {
      let textToCopy = data.meeting_url
      // Create HTML Element
      const selBox = document.createElement('textarea')

      // Set the Styles
      selBox.style.position = 'fixed'
      selBox.style.left = '0'
      selBox.style.top = '0'
      selBox.style.opacity = '0'

      // Set the value
      selBox.value = textToCopy

      // Append the child to the body
      document.body.appendChild(selBox)

      // Append Focus and select
      selBox.focus()
      selBox.select()

      // Execute the command to copy
      document.execCommand('copy')

      // Remove the child once done
      document.body.removeChild(selBox)

      this.$bvToast.toast('Link Copied', {
        title: `Success`,
        toaster: 'b-toaster-top-right',
        solid: true,
        variant: 'success',
        appendToast: false,
      })
    },
  },
}
</script>

<template>
  <div>
    <v-app>
      <v-main>
        <v-container>
          <v-row>
            <v-col md="3">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                @keypress="restrictChars($event)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                :headers="fields"
                :items="items"
                :items-per-page="5"
                :display-fields="displayFields"
                :search="search"
                :custom-filter="filterData"
                :hide-default-footer="true"
                class="elevation-1"
              >
                <template v-slot:top="{ pagination, options, updateOptions }">
                  <v-data-footer
                    :pagination="pagination"
                    :options="options"
                    items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                    @update:options="updateOptions"
                  />
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <b-badge v-if="item.status" variant="success">Done</b-badge>
                  <b-badge v-else variant="danger">Pending</b-badge>
                </template>
                <template v-slot:[`item.loginStatus`]="{ item }">
                  <b-badge v-if="item.loginStatus" variant="success"
                    >Active</b-badge
                  >
                  <b-badge v-else variant="danger">Inactive</b-badge>
                </template>
                <template v-slot:[`item.date`]="{ item }">{{
                  formatDates(item.date)
                }}</template>
                <template v-slot:[`item.deadline`]="{ item }">{{
                  formatDates(item.deadline)
                }}</template>
                <template v-slot:[`item.start`]="{ item }">{{
                  formatDates(item.start)
                }}</template>
                <template v-slot:[`item.end`]="{ item }">{{
                  formatDates(item.end)
                }}</template>
                <template v-slot:[`item.meetingtime`]="{ item }">{{
                  getMeetingTime(item.start_time)
                }}</template>
                <template v-slot:[`item.eventtime`]="{ item }">{{
                  getEventTime(item.time)
                }}</template>
                <template v-slot:[`item.eventstatus`]="{ item }">
                  <h5 style="padding-left: 40px !important"
                    ><b-badge v-if="item.status === 'true'" variant="success"
                      >Yes</b-badge
                    >
                    <b-badge v-else variant="danger">No</b-badge>
                  </h5>
                </template>
                <template v-slot:[`item.document`]="{ item }">
                  <div v-if="item.document.length >= 1">
                    <div
                      v-for="(item1, index1) in item.document"
                      :key="`list${index1}`"
                    >
                      <div v-if="index1 + 1 === item.document.length">{{
                        item1
                      }}</div>
                      <div v-else>{{ item1 }},</div>
                    </div>
                  </div>
                  <div v-else>NA</div>
                </template>
                <template v-slot:[`item.courseId`]="{ item }">
                  <div
                    v-for="(item1, index1) in item.course_id"
                    :key="`list${index1}`"
                  >
                    <p v-if="index1 + 1 === item.course_id.length">{{
                      item1.name
                    }}</p>
                    <p v-else>{{ item1.name }},</p>
                  </div>
                </template>
                <template v-slot:[`item.assignedTo`]="{ item }">
                  <a
                    v-b-modal="'users-modal'"
                    style="color: blue"
                    @click="showAssignedUsers(item)"
                    >Assigned Students List</a
                  >
                </template>
                <template v-slot:cell(enterprise)="data">
                  <p v-if="data.item.platform_id === 0">All</p>
                  <p v-else>{{ data.item.config_info.site_name }}</p>
                </template>
                <template v-slot:cell(collegeId)="data">
                  <ul>
                    <li v-for="item in data.item.college" :key="item._id">
                      {{ item.site_name }}
                    </li>
                  </ul>
                </template>
                <template v-slot:[`item.categoryName`]="{ item }">
                  <div v-if="item.category">{{ item.category.name }}</div>
                </template>
                <template v-slot:[`item.categoryData`]="{ item }">
                  <div v-if="item.categoryData.length >= 1">{{
                    item.categoryData[0].name
                  }}</div>
                  <div v-else>-</div>
                </template>
                <template v-slot:[`item.platformName`]="{ item }">
                  <p v-if="item.platformData.length >= 1">{{
                    item.platformData[0].site_name
                  }}</p>
                </template>
                <template v-slot:cell(subcategoryName)="data">
                  <p v-if="data.item.subcategory">{{
                    data.item.subcategory.name
                  }}</p>
                </template>
                <template v-slot:[`item.department`]="{ item }">
                  <div
                    v-if="item.department && item.departmentData.length !== 0"
                    >{{ item.departmentData[0].name }}</div
                  >
                </template>
                <template v-slot:[`item.college_id`]="{ item }">
                  <div v-if="item.collegeData.length >= 1">{{
                    item.collegeData.name
                  }}</div>
                </template>
                <template v-slot:[`item.dept_college_id`]="{ item }">
                  <div v-if="item.collegeData.length >= 1">{{
                    item.collegeData[0].name
                  }}</div>
                </template>
                <template v-slot:[`item.admin_college_id`]="{ item }">
                  <div v-if="item.collegeData.length >= 1">{{
                    item.collegeData[0].name
                  }}</div>
                  <div v-else>-</div>
                </template>
                <template v-slot:[`item.description1`]="{ item }">
                  <div v-html="item.description"></div>
                </template>
                <template v-slot:[`item.assigned_to_resource`]="{ item }">
                  <div
                    v-for="(item1, index1) in item.assigned_to"
                    :key="`list${index1}`"
                  >
                    <div v-if="item1.name !== undefined">
                      <p v-if="index1 + 1 === item.assigned_to.length">{{
                        item1.name
                      }}</p>
                      <p v-else>{{ item1.name }},</p>
                    </div>
                    <div v-else>
                      <p v-if="index1 + 1 === item.assigned_to.length">{{
                        item1
                      }}</p>
                      <p v-else>{{ item1 }},</p>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(report_status)="data">
                  <b-badge
                    v-if="
                      data.item.status !== '' && data.item.status === 'pending'
                    "
                    variant="danger"
                    >{{ data.item.status }}</b-badge
                  >
                  <b-badge
                    v-if="
                      data.item.status !== '' && data.item.status === 'done'
                    "
                    variant="success"
                    >{{ data.item.status }}</b-badge
                  >
                </template>

                <!--  Toggle detail view of table row  start  -->
                <template v-slot:[`item.detailAction`]="row">
                  <b-button
                    size="sm"
                    class="mr-2 details-button"
                    variant="link"
                    @click="expandTable(row)"
                    >{{
                      row.detailsShowing ? 'Hide' : 'Show'
                    }}
                    Details</b-button
                  >
                </template>

                <TableDetail
                  v-if="showSession"
                  :data="item"
                  table-name="course"
                ></TableDetail>

                <!--  Toggle detail view of table row end  -->

                <!-- A custom formatted header cell for item 'name' -->
                <template v-slot:[`item.action`]="{ item }">
                  <b-button-group>
                    <b-button
                      v-if="copybtn && item.added_by === currentUser.user._id"
                      v-b-tooltip.hover
                      title="Copy Meeting Link"
                      variant="primary"
                      size="sm"
                      @click="copyMeetingUrl(item)"
                      ><i class="ti-link icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="viewbtn"
                      v-b-modal="'my-modal'"
                      v-b-tooltip.hover
                      title="View"
                      variant="success"
                      size="sm"
                      @click="getdata(item)"
                      ><i class="ti-eye icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="showdetail && editcourse"
                      v-b-modal="'my-modal'"
                      v-b-tooltip.hover
                      title="View"
                      variant="success"
                      size="sm"
                      @click="redirectCourse(item)"
                      ><i class="ti-eye icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        editbtn &&
                        event &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'event-update-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getEventEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>

                    <b-button
                      v-if="editbtn && role === COLLEGE_ROLE && teacher"
                      v-b-modal="'teacher-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getTeacherEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        assignment &&
                        item.assigned_by.id === currentUser.user._id
                      "
                      v-b-modal="'assignment-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getAssignmentEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        resource &&
                        item.assigned_by.id === currentUser.user._id
                      "
                      v-b-modal="'resource-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getResourceEdit(item)"
                      ><i class="ti-pencil-alt"></i
                    ></b-button>

                    <b-button
                      v-else-if="
                        editbtn &&
                        calendarEvent &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'course-event-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getCalendarEventEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        liveclass &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'meeting-edit-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getMeetingEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        category &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'category-edit-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getCategoryEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        subcategory &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'sub-category-edit-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getSubCategoryEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        editcourse &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'course-edit-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getCourseEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        editcoursecontent &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'course-content-edit-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getCourseContentEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        trainingEvent &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'training-event-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getTrainingEventEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="editbtn && role === COLLEGE_ROLE && user"
                      v-b-modal="'user-edit-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getUserDataEdit(item)"
                      ><i class="ti-pencil-alt"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        (role === COLLEGE_ROLE || role === TEACHER_ROLE) &&
                        batch
                      "
                      v-b-modal="'batch-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getBatchEdit(item)"
                      ><i class="ti-pencil-alt"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        blog &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'blog-update-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getBlogEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="editbtn && admin"
                      v-b-modal="'admin-update-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getAdminEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="editbtn && college"
                      v-b-modal="'college-update-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getCollegeEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn && collegeClass && role === COLLEGE_ROLE
                      "
                      v-b-modal="'collegeclass-update-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getCollegeClassEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-else-if="
                        editbtn &&
                        department &&
                        (role === COLLEGE_ROLE || role === ADMINISTRATOR_ROLE)
                      "
                      v-b-modal="'department-update-modal'"
                      v-b-tooltip.hover
                      title="Edit"
                      variant="primary"
                      size="sm"
                      @click="getDepartmentEdit(item)"
                      ><i class="ti-pencil-alt icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        (role === COLLEGE_ROLE ||
                          role === ADMINISTRATOR_ROLE) &&
                        department
                      "
                      v-b-modal="'department-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getDepartmentDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="deletebtn && role === COLLEGE_ROLE && user"
                      v-b-modal="'user-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getUserDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="deletebtn && admin"
                      v-b-modal="'admin-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getAdminDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="deletebtn && college && role === ADMIN_ROLE"
                      v-b-modal="'college-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getCollegeDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="deletebtn && collegeClass && role === COLLEGE_ROLE"
                      v-b-modal="'collegeclass-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getCollegeClassDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        event &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'event-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getEventDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        blog &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'blog-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getBlogDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="deletebtn && role === COLLEGE_ROLE && teacher"
                      v-b-modal="'teacher-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getTeacherDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        calendarEvent &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getCalendarEventDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        trainingEvent &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'training-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getTrainingEventDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        resource &&
                        item.assigned_by.id === currentUser.user._id
                      "
                      v-b-modal="'resource-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getResourceDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        assignment &&
                        item.assigned_by.id === currentUser.user._id
                      "
                      v-b-modal="'assignment-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getAssignmentDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="joinbtn && item.added_by === currentUser.user._id"
                      v-b-tooltip.hover
                      title="Join Meeting"
                      variant="warning"
                      size="sm"
                      @click="redirectMeeting(item)"
                      ><i class="ti-share icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        liveclass &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'meeting-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getMeetingDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        category &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'category-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getCategoryDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        subcategory &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'sub-category-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getSubCategoryDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        editcourse &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'course-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getCourseDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        deletebtn &&
                        editcoursecontent &&
                        item.added_by === currentUser.user._id
                      "
                      v-b-modal="'course-content-delete-modal'"
                      v-b-tooltip.hover
                      title="Delete"
                      variant="danger"
                      size="sm"
                      @click="getCourseContentDelete(item)"
                      ><i class="ti-close icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="downloadbtn && role === ADMIN_ROLE"
                      v-b-tooltip.hover
                      title="Download"
                      variant="default"
                      size="sm"
                      ><i class="ti-download icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        addbtn &&
                        role === ADMIN_ROLE &&
                        data.item.status === 'pending'
                      "
                      v-b-modal="'add-modal'"
                      v-b-tooltip.hover
                      title="Add"
                      variant="primary"
                      size="sm"
                      @click="approvaldata(data.item)"
                      ><i class="ti-pencil-alt"></i
                    ></b-button>
                  </b-button-group>
                </template>
                <template v-slot:[`item.action1`]="{ item }">
                  <b-button-group>
                    <b-button
                      v-if="
                        uploadbtn &&
                        item.status === 'pending' &&
                        role === ADMIN_ROLE
                      "
                      v-b-modal="'upload-modal'"
                      v-b-tooltip.hover
                      title="Upload"
                      variant="info"
                      size="sm"
                      @click="uploadReport(item)"
                      ><i class="ti-upload icon-white"></i
                    ></b-button>
                    <b-button
                      v-if="
                        viewbtn &&
                        item.type &&
                        item.type !== 'custom' &&
                        item.type !== 'requested'
                      "
                      v-b-tooltip.hover
                      title="View"
                      variant="success"
                      size="sm"
                      :to="'/report-list/' + item.type"
                      ><i class="ti-eye icon-white"></i
                    ></b-button>
                    <DownloadButton
                      v-if="downloadbtn && item.status !== 'pending'"
                      v-b-tooltip.hover
                      title="Download"
                      :type="item.type"
                      :downloadtype="'excel'"
                      :item="item"
                      style="color: white"
                    >
                    </DownloadButton>
                  </b-button-group>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
    <Detail
      v-if="active"
      :data="details"
      :size="size"
      :display="displayFields"
    ></Detail>
    <Approval v-if="approveActive" :data="approvalDetails"></Approval>
    <Update v-if="update" :data="reportData"></Update>
    <Upload v-if="upload" :data="Report"></Upload>
    <BatchUpdate v-if="batchEdit" :data="batchData"></BatchUpdate>
    <AssignedUser v-if="showUsers" :data="usersData"></AssignedUser>
    <TeacherDataUpdate
      v-if="teacherEdit"
      :data="teacherData"
    ></TeacherDataUpdate>
    <AssignmentUpdate
      v-if="assignmentEdit"
      :data="assignmentData"
    ></AssignmentUpdate>
    <CalendarEventUpdate
      v-if="calendarEventEdit"
      :data="calendarEventData"
    ></CalendarEventUpdate>
    <CalendarEventDelete
      v-if="deleteEvent"
      :data="deleteData"
    ></CalendarEventDelete>
    <TrainingEventUpdate
      v-if="trainingEventEdit"
      :data="trainingEventData"
    ></TrainingEventUpdate>
    <TrainingEventDelete
      v-if="deleteTrainingEvent"
      :data="deleteTrainingData"
    ></TrainingEventDelete>
    <ResourceUpdate v-if="resourceEdit" :data="resourceData"></ResourceUpdate>
    <ResourceDelete
      v-if="deleteResource"
      :data="deleteResourceData"
    ></ResourceDelete>
    <AssignmentDelete
      v-if="deleteAssignment"
      :data="deleteAssignmentData"
    ></AssignmentDelete>
    <MeetingUpdate v-if="meetingEdit" :data="meetingEditData"></MeetingUpdate>
    <MeetingDelete
      v-if="meetingDelete"
      :data="meetingDeleteData"
    ></MeetingDelete>
    <CategoryUpdate
      v-if="categoryEdit"
      :data="categoryEditData"
    ></CategoryUpdate>
    <CategoryDelete
      v-if="categoryDelete"
      :data="categoryDeleteData"
    ></CategoryDelete>
    <SubCategoryUpdate
      v-if="subCategoryEdit"
      :data="subCategoryEditData"
    ></SubCategoryUpdate>
    <SubCategoryDelete
      v-if="subCategoryDelete"
      :data="subCategoryDeleteData"
    ></SubCategoryDelete>
    <CourseUpdate v-if="courseEdit" :data="courseEditData"></CourseUpdate>
    <CourseDelete v-if="courseDelete" :data="courseDeleteData"></CourseDelete>
    <CourseContentUpdate
      v-if="courseContentEdit"
      :data="courseContentEditData"
    ></CourseContentUpdate>
    <CourseContentDelete
      v-if="courseContentDelete"
      :data="courseContentDeleteData"
    ></CourseContentDelete>
    <UserUpdate v-if="userUpdate" :data="userUpdateData"> </UserUpdate>
    <UserDelete v-if="userDelete" :data="userDeleteData"> </UserDelete>
    <TeacherDelete v-if="teacherDelete" :data="teacherDeleteData">
    </TeacherDelete>
    <EventUpdate v-if="eventUpdate" :data="eventUpdateData"></EventUpdate>
    <EventDelete v-if="eventDelete" :data="eventDeleteData"></EventDelete>
    <BlogUpdate v-if="blogUpdate" :data="blogUpdateData"></BlogUpdate>
    <BlogDelete v-if="blogDelete" :data="blogDeleteData"></BlogDelete>
    <AdminUpdate v-if="adminUpdate" :data="adminUpdateData"></AdminUpdate>
    <AdminDelete v-if="adminDelete" :data="adminDeleteData"></AdminDelete>
    <CollegeUpdate
      v-if="collegeUpdate"
      :data="collegeUpdateData"
    ></CollegeUpdate>
    <CollegeDelete
      v-if="collegeDelete"
      :data="collegeDeleteData"
    ></CollegeDelete>
    <CollegeClassUpdate
      v-if="collegeClassUpdate"
      :data="collegeClassUpdateData"
    ></CollegeClassUpdate>
    <CollegeClassDelete
      v-if="collegeClassDelete"
      :data="collegeClassDeleteData"
    ></CollegeClassDelete>
    <DepartmentUpdate
      v-if="departmentUpdate"
      :data="departmentUpdateData"
    ></DepartmentUpdate>
    <DepartmentDelete
      v-if="departmentDelete"
      :data="departmentDeleteData"
    ></DepartmentDelete>
  </div>
</template>
<style>
@media (min-width: 768px) {
  .details-button {
    margin-left: -12px;
  }
}
.pullRight {
  float: right;
}
.capital {
  text-transform: uppercase;
}
#status {
  display: block !important;
}
.v-menu__content {
  top: 210px !important;
  left: 755px !important;
}
.scroll {
  overflow-y: auto !important;
}
th.text-start {
  font-size: 16px !important;
}
.icon-white {
  color: white !important;
}
</style>
